'use client'

import {
	CartProduct,
	OrderFlowMode,
	OrderFlowProvider
} from '@/app/[locale]/order/_context/order-flow-context'

import { DirectOrderFlow } from './_components/direct-order-flow'
import { StandardOrderFlow } from './_components/standard-order-flow'

type AOrderFlowClientProps = {
	initialFlowMode?: OrderFlowMode
	initialAmbulanceSlug?: string | null
	initialEmployeeSlug?: string | null
	initialCart?: CartProduct[]
}

/**
 * Client root for `/order`: provides {@link OrderFlowProvider} and renders standard vs direct funnel.
 */
export function AOrderFlowClient({
	initialFlowMode,
	initialAmbulanceSlug,
	initialEmployeeSlug,
	initialCart
}: AOrderFlowClientProps) {
	return (
		<OrderFlowProvider
			initialFlowMode={initialFlowMode}
			initialAmbulanceSlug={initialAmbulanceSlug}
			initialEmployeeSlug={initialEmployeeSlug}
			initialCart={initialCart}
		>
			<div>
				{initialFlowMode === OrderFlowMode.DIRECT ? <DirectOrderFlow /> : <StandardOrderFlow />}
			</div>
		</OrderFlowProvider>
	)
}
